import axios from "axios";
import { CONVERSATIONS_ITEM_COMPLETE } from "./type";
import { DEAL_STATUS, STATUS_PERSON } from 'constants/chatConstants';
import { CHAT_CONVERSATION } from "endpointsConst";

export function completeConversationItem(conversationId, item, isMyEntity, lang) {
  const { type, id, conversation_entity_id } = item;

  return async (dispatch) => {
    try {
      await axios
        .patch(`${CHAT_CONVERSATION}/${conversationId}/${conversation_entity_id}/complete/${id}`, null, {
          params: {
            type,
            lang,
          },
        })
        .then(() => {
          const status_name = isMyEntity ? STATUS_PERSON.OWNER_STATUS : STATUS_PERSON.CLIENT_STATUS;
          dispatch({
            type: CONVERSATIONS_ITEM_COMPLETE,
            payload: {
              conversation_id: conversationId,
              type,
              type_id: id,
              isMyChanges: true,
              status_name,
              status: DEAL_STATUS.COMPLETED,
            },
          });
        });
    } catch (error) {
      // TODO handle error
    }
  };
}
